module.exports = __webpack_public_path__ + "static/models/cage_start.971df84.json";


//////////////////
// WEBPACK FOOTER
// ./src/assets/models/track/models/cage_start.json
// module id = 538
// module chunks = 1